import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ModalPreview } from "expano-components";
import ModalPhoto from "./components/ModalPhoto";

import {
  setTakePhotoModalKind,
  openSpeditorModal,
  downloadGdnLabel,
} from "actions/pack_gdn";

import { useCable } from "providers/cable";

import { ReactComponent as ImageIcon } from "icons/image.svg";
import { ReactComponent as PacksIcon } from "icons/packs.svg";
import { ReactComponent as PackIcon } from "icons/pack.svg";
import { ReactComponent as ArrowPrevIcon } from "icons/arrow-back.svg";

const Header = ({
  data,
  getData,
  take_photo_modal_kind,
  setTakePhotoModalKind,
  openSpeditorModal,
}) => {
  const images = [
    {
      name: "Główne",
      kind: "photo",
      image_url: data?.photo_url,
      show: true,
    },
    {
      name: "Dodatkowe",
      kind: "first_additional_photo",
      image_url: data?.first_additional_photo_url,

      show: !!data?.photo_url,
    },
    {
      name: "Dodatkowe",
      kind: "second_additional_photo",
      image_url: data?.second_additional_photo_url,
      show: !!data?.first_additional_photo_url,
    },
    {
      name: "Nadstan",
      kind: "over_pack_photo",
      image_url: data?.over_pack_photo_url,
      show: !!data?.over_pack_photo_url,
    },
  ];

  const gdn_id = data.id;

  const { cable } = useCable();

  const [channel, setChannel] = useState(null);
  const [is_downloading, setDownloading] = useState(false);

  const [modal_preview_image, setModalPreviewImage] = useState(null);

  useEffect(() => {
    const cable_channel = cable.subscriptions.create({
      channel: "PackerChannel",
    });

    setChannel(cable_channel);

    return () => {
      if (cable_channel) {
        setChannel(null);
        cable_channel.unsubscribe();
      }
    };
  }, [gdn_id]);

  const can_back_to_pack = [
    "completed",
    "problem",
    "with_missings",
    "with_missings_confirmed",
    "to_cancel",
    "error",
    "need_verification",
  ].includes(data.status);

  const sendMessage = (gdn_id, kind = "photo") =>
    channel?.perform("init_gdn_photo", { gdn_id, kind });

  return (
    <>
      {take_photo_modal_kind && (
        <ModalPhoto
          kind={take_photo_modal_kind}
          sendMessage={sendMessage}
          getData={getData}
          gdn_id={gdn_id}
          handleClose={() => setTakePhotoModalKind(null)}
          openSpeditorModal={openSpeditorModal}
        />
      )}
      {modal_preview_image &&
        ReactDOM.createPortal(
          <ModalPreview
            handleClose={() => setModalPreviewImage(null)}
            src={modal_preview_image}
            name=""
          />,
          document.getElementById("root")
        )}
      <div className="packs-topbar">
        <div className="packs-topbar__container">
          <div className="packs-topbar__left">
            {can_back_to_pack && (
              <Link
                className="btn btn-default m-r-15"
                to={
                  data?.gdn_pack?.id
                    ? `/packing/gdn_pack/${data.gdn_pack.id}`
                    : `/packing`
                }
              >
                <ArrowPrevIcon style={{ transform: "scaleX(-1)" }} />
                <span>Wroć do paka</span>
              </Link>
            )}
            <div className="pack-number">
              <div className="pack-number__icon">
                <PacksIcon />
              </div>
              <div className="pack-number__text">
                {is_downloading ? (
                  <p>Proszę czekać...</p>
                ) : (
                  <p
                    className="link"
                    onClick={async () => {
                      try {
                        setDownloading(true);
                        await downloadGdnLabel({
                          expano_oms_id: data.expano_oms_id,
                          id: data.id,
                        });
                      } catch (error) {
                        console.log(error);
                      } finally {
                        setDownloading(false);
                      }
                    }}
                  >
                    {data?.expano_oms_id}
                  </p>
                )}
              </div>
            </div>
            {data?.picking_box && (
              <div className="packing-box-group">
                <span>{data.picking_box}</span>
              </div>
            )}
            <div className="speditor-group">
              <p className="speditor-group__title">Metoda dostawy</p>
              <p className="speditor-group__info">
                <span>
                  {data?.delivery_country_code
                    ? `[${data.delivery_country_code}]`
                    : ""}{" "}
                  {data?.delivery_price
                    ? `[${data.delivery_price} ${data?.currency}]`
                    : ""}{" "}
                  {data?.declared_packages_count
                    ? `${data?.declared_packages_count} x`
                    : ""}{" "}
                  {data?.delivery_method_name}
                </span>
              </p>
            </div>
            {!!data.packing_box_size && (
              <div className="pack-group">
                <div className="pack-group__image">
                  <PackIcon />
                </div>
                <div className="pack-group__text">
                  <p className="pack-group__title">Spakuj zamówienie w</p>
                  <p className="pack-group__value">{data.packing_box_size}</p>
                </div>
              </div>
            )}
          </div>
          <div className="packs-topbar__right">
            <div className="image-upload">
              {images.map(({ image_url, name, kind, show }) => {
                if (!show) {
                  return null;
                }
                return image_url ? (
                  <button
                    onClick={() => setModalPreviewImage(image_url)}
                    className="preview image"
                    style={{
                      backgroundImage: `url(${image_url})`,
                    }}
                  />
                ) : (
                  <button
                    className="image"
                    onClick={() => setTakePhotoModalKind(kind)}
                  >
                    <ImageIcon />
                    <span>{name}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(
  ({ pack_gdn: { data, take_photo_modal_kind } }) => ({
    data,
    take_photo_modal_kind,
  }),
  (dispatch) => ({
    setTakePhotoModalKind: (kind) => dispatch(setTakePhotoModalKind(kind)),
    openSpeditorModal: (is_open) => dispatch(openSpeditorModal(is_open)),
  })
)(Header);
